
import * as React from "react";
import { isEmpty as _isEmpty } from "lodash";
import { connect } from "react-redux";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import IPatientCompleteInfo from "../../models/patients/IPatientCompleteInfo";
import { RouteUtils } from "../../routes";
import { AppMessages } from "../../utils/AppConstants";
import { default as AppUtils } from "../../utils/AppUtils";
import { EventNames } from "../../utils/EventTrackerConstants";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { Tracker } from "../../utils/Tracker";
import { IAppState } from "../../models/IAppState";
import ConsultationFeedbackForm from "../ConsultationFeedbackFormContainer/ConsultationFeedbackForm";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import { HeaderWithDescription } from "../../components/common/HeaderWithDescription";

interface PdfSaveSuccessStateProps {
  submittedConsultationFeedbackForms: Array<number>
}

interface PdfSaveSuccessDispatchProps {
  storeSubmitConsultationFeedback: (consultationId: number) => void;
}

export interface PdfSaveSuccessProps {
  consultationId: number,
  patientDetails: IPatientCompleteInfo,
  ongoingConsultation: IOngoingConsultation,
  userId?: number,
  toggleModal: (flag: boolean) => void,
  showDifferentialDiagnosisModal: () => void,
  pdfData: File,
  printPdf: () => void,
  uploadPdf: () => Promise<any>,
  savePrescriptionAsTemplate: () => void,
  isTreatmentPlanEnabled: boolean,
}

enum BtnType {
  primary = "primary",
  secondary = "secondary"
}

const Button = (props: { className: string, value: string, clickHandler: (e: any) => void, styles?: { color: string }, btnType?: BtnType } = { className: "", value: "", clickHandler: () => { } }) => {
  let btnCls = "cf-btn-gradient"
  if (props.btnType && props.btnType === BtnType.secondary) btnCls += " " + "cf-btn-rounded-bordered";
  btnCls += " " + props.className
  return (
    <input
      className={btnCls}
      type="button"
      value={props.value}
      style={{ ...props.styles }}
      onClick={props.clickHandler}
    />
  )
}

const CtaComp = (props: { value: string, callBack: (id: string) => void, actionId: string, iconUrl?: string, shouldShowPulse?: boolean }) => {
  const imageClassName: string = `cta-container-img ${props.shouldShowPulse ? "pulse" : ""}`;
  console.log(imageClassName, props);
  return (
    <div className="cta-container-item" onClick={() => props.callBack(props.actionId)}>
      {props.iconUrl && <img className={imageClassName} src={props.iconUrl} />}
      <div className="cta-container-text">{props.value}</div>
    </div>
  )
}

class PdfSaveSuccessModal extends React.Component<PdfSaveSuccessProps & PdfSaveSuccessStateProps & PdfSaveSuccessDispatchProps> {

  ctaItems = [
    { iconUrl: "/images/write.svg", txt: "Write private note", actionId: "privateNotes" },
    ...((this.props.ongoingConsultation.appointmentSchedule.consultationProduct.hasPrescription &&
      this.props.isTreatmentPlanEnabled) ? [{ iconUrl: "/images/template.svg", txt: "Save as template", actionId: "saveTemplate", shouldShowPulse: true }] : []),
    ...(!AppUtils.isMindConsultation(this.props.ongoingConsultation.appointmentSchedule) ? [{ iconUrl: "/images/print.svg", txt: "Print prescription", actionId: "printPrescription" }] : [])
  ]

  preventModalClose = (event: any) => {
    event.stopPropagation();
  };

  handleCompletionClick = (event: React.MouseEvent<HTMLInputElement>) => {
    LocalStorageUtils.setClickEvents({ field: "Proceed to Completion", section: EventNames.Complete_Prescription + "Success", widget: EventNames.Print_Prescription })
    event.preventDefault();
    Tracker.track(EventNames.Proceed_to_Completion_clicked, { appointmentId: this.props.consultationId })
    this.props.uploadPdf().then(() => {
      this.props.showDifferentialDiagnosisModal();
    });
  };

  handleCtaClick = (actionId: string) => {
    switch (actionId) {
      case "privateNotes":
        this.props.showDifferentialDiagnosisModal()
        break;
      case "saveTemplate":
        this.props.savePrescriptionAsTemplate()
        break;
      case "printPrescription":
        this.props.printPdf()
        break;
    }
  }

  render() {
    let pdfPrescription = null, isPlan = false;
    if (this.props.ongoingConsultation && this.props.ongoingConsultation.medicalProfile) {
      pdfPrescription = { ...this.props.ongoingConsultation.medicalProfile };
      pdfPrescription.prescription = this.props.ongoingConsultation.medicalProfile.currentConsultationData
        ? { ...this.props.ongoingConsultation.medicalProfile.currentConsultationData } : null;
      // pdfPrescription.prescription = this.props.ongoingConsultation.currentPrescription ? {...this.props.ongoingConsultation.currentPrescription} : null;
      isPlan = this.props.ongoingConsultation.appointmentSchedule.consultationProduct.isPlan;
    }

    let prescription = this.props.ongoingConsultation.medicalProfile.currentConsultationData;
    const messageToDisplay = isPlan ? AppMessages.SAVE_PLAN_SUCCESSFUL : AppMessages.SAVE_PRESCRIPTION_SUCCESSFUL;
    return (
      <div
        className={"prescription-successful-save-container"}
        onClick={this.preventModalClose}
      >
        <HeaderWithDescription
          text={"Prescription Saved Successfully"}
        // description={"The prescription has been emailed to the patient and is available on his cure.fit app"}
        />
        <div className={"body-container"}>
          <div className="save-button collapsible-card button-container">
            <Button
              className={""}
              value={"Logout"}
              clickHandler={() => AppUtils.logout()}
              btnType={BtnType.secondary}
            />
            {!AppUtils.getIsMobile() && (
              <Button
                className={""}
                value={"Next Consultation"}
                clickHandler={() => RouteUtils.navigateToDashboard()}
                styles={{ color: "white" }}
                btnType={BtnType.primary}
              />
            )}
          </div>
        </div>
        <div className={"footer"}>
          <div className={"cta-container prescription-complete-cta"}>
            {this.ctaItems.map((ctaItem: any, index: number) => (
              <CtaComp
                key={`cta-${index}`}
                value={ctaItem.txt}
                callBack={this.handleCtaClick}
                actionId={ctaItem.actionId}
                iconUrl={ctaItem.iconUrl}
                shouldShowPulse={ctaItem.shouldShowPulse}
              />
            ))}
          </div>
          <ConsultationFeedbackForm
            consultationId={this.props.consultationId}
            submitConsultationForm={this.props.storeSubmitConsultationFeedback}
            isFormAlreadySubmitted={this.props.submittedConsultationFeedbackForms.includes(this.props.consultationId)}
          />
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: any): PdfSaveSuccessDispatchProps {
  return {
    storeSubmitConsultationFeedback: (consultationId: number) => {
      return OngoingConsultationActions.submitConsultationFeedbackForm(dispatch, consultationId);
    }
  }
}

function mapStateToProps(state: IAppState): PdfSaveSuccessStateProps {
  return {
    submittedConsultationFeedbackForms: state.ongoingConsultation.submittedConsultationForms || []
  }
}

export default connect<PdfSaveSuccessStateProps, PdfSaveSuccessDispatchProps, PdfSaveSuccessProps>(mapStateToProps, mapDispatchToProps)(PdfSaveSuccessModal);
